<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleCancel">
      <span slot="title">审核拒绝</span>
      <div class="pass-reject-refuse-box" v-loading="loading">
        <div class="pass-reject-refuse-tip">
          <span style="color: #ff3939">*</span>
          <span>原因</span>
        </div>
        <el-input v-model="reason" placeholder="请输入" size="mini" />
        <div class="pass-reject-refuse-button">
          <el-button plain size="mini" @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            size="mini"
            :disabled="!reason"
            @click="handleSubmit"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PassReject",
  components: {},
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      loading: false,
      form: {},
      reason: "",
    };
  },
  methods: {
    handleCancel() {
      this.reason = "";
      this.dialogCodeVisible = false;
    },
    async handleSubmit() {
      this.loading = true;
      await this.$api.prescription.RejectPrescription({
        prescriptionId: this.form.id,
        reason: this.reason,
      });
      this.loading = false;
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.form = row;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./passRejectRefuse.scss";
</style>
